import { Button } from "ui-kit/Button";
import { AttsIcon } from "assets/svgComponents/PresaleBlock/ConnectWallet copy";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TokenIcon from "assets/svgComponents/header/TokenIcon";
import Whitepaper from "assets/svgComponents/header/Whitepaper";
import QuestionMark from "assets/svgComponents/statsBlock/QuestionMark";
import { NavItem } from "./NavItem";
import DashboardIcon from "assets/svgComponents/dashboardTopBlock/DashboardIcon";
import ReferralsIcon from "assets/svgComponents/referralsPage/ReferralsIcon";
import AnimatedButton from "../../PresentationSection/AnimatedButton";
import { useTranslation } from "react-i18next";

export const NAVIGATION_LANDING = (t: any) => [
  {
    label: t("navigation.token"),
    link: "#token",
    icon: (
      <TokenIcon className={"size-[1.4vw] max-lg:w-[4vw] max-lg:h-[4vw]"} />
    ),
  },
  {
    label: t("navigation.whitepaper"),
    link: "https://docs.agnthub.ai",
    icon: (
      <Whitepaper className={"size-[1.4vw] max-lg:w-[5vw] max-lg:h-[5vw]"} />
    ),
  },
  {
    label: t("navigation.faq"),
    link: "#faq",
    icon: (
      <QuestionMark className={"size-[1.3vw] max-lg:w-[5vw] max-lg:h-[5vw]"} />
    ),
  },
];

export const NAVIGATION_DASHBOARD = (t: any) => [
  {
    id: 1,
    label: t("navigation.dashboard"),
    link: "/dashboard",
    icon: (
      <DashboardIcon className={"size-[1.4vw] max-lg:w-[5vw] max-lg:h-[5vw]"} />
    ),
  },
  {
    id: 2,
    label: t("navigation.referrals"),
    link: "/referrals",
    icon: (
      <ReferralsIcon className={"size-[1.4vw] max-lg:w-[5vw] max-lg:h-[5vw]"} />
    ),
  },
];

const Navigation = ({ isDark }: { isDark?: boolean }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;

  const isLanding = pathname === "/";

  return (
    <nav className="lg:block hidden">
      <ul className="flex gap-[0.65vw]">
        {isLanding ? (
          <>
            {NAVIGATION_LANDING(t).map((link) => {
              return (
                <NavItem
                  label={link.label}
                  icon={link.icon}
                  link={link.link}
                  key={link.label}
                  isLink={link.link.startsWith("http")}
                  isDark={isDark}
                />
              );
            })}
            <div className="relative">
              <li>
                <Link to={"/dashboard"}>
                  {" "}
                  <Button
                    className="inline-flex  items-center justify-center gap-[0.83vw] pl-[0.56vw] pr-[1.39vw]  !py-[0.65vw] h-auto !rounded-[1.11vw]
                       border-none shadow-[0px_0.42vw_0.52vw_0px_#0000000f] 
                       bg-[linear-gradient(90deg,rgba(255,166,134,1)_0%,rgba(255,173,174,1)_40%,rgba(207,178,255,1)_100%),linear-gradient(0deg,rgba(233,235,243,1)_0%,rgba(233,235,243,1)_100%)] 
                       before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] before:rounded-[1.11vw] before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] 
                       before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] 
                       before:[mask-composite:exclude] before:z-[1] before:pointer-events-none hover:opacity-90 transition-opacity"
                  >
                    <div className="flex bg-white rounded-[0.56vw] items-center justify-center w-[1.94vw] h-[1.94vw]">
                      <AttsIcon width="1.67vw" height="1.67vw" />
                    </div>{" "}
                    <span className="font-luxora-medium  font-normal text-white text-[0.97vw] tracking-[0] leading-[1.07vw] whitespace-nowrap">
                      {t("navigation.getAttsToken")}
                    </span>
                  </Button>
                </Link>
              </li>
            </div>
          </>
        ) : (
          <>
            {NAVIGATION_DASHBOARD(t).map((link) => {
              return (
                <NavItem
                  isLink={true}
                  label={link.label}
                  icon={link.icon}
                  link={link.link}
                  key={link.label}
                  isDark={isDark}
                />
              );
            })}

            <AnimatedButton isHeader />
          </>
        )}
        {/* <li>
            {isConnected && address ? (
              <div className="flex gap-2 justify-items-end justify-self-end">
                <WalletPopover>
                  <Button
                    className="h-[3.857em] text-black px-7 gap-1 md:p-0 md:w-[3.857em]"
                    variant="primary"
                  >
                    <img src={walletIcon} className="w-5 h-5" alt="" />
                    <span className="md:hidden">
                      {formatAddress(address, 4, 3)}
                    </span>
                    <TriangleDown
                      width={16}
                      height={16}
                      color="black"
                      className="md:hidden"
                    />
                  </Button>
                </WalletPopover>
              </div>
            ) : (
              <div className="flex gap-4 justify-items-end justify-self-end">
                <Button
                  onClick={openConnectModal}
                  className="h-[3.857em] w-[14em] md:px-3 text-[#000]"
                  variant="primary"
                >
                  <span className="">Connect Wallet</span>
                </Button>
              </div>
            )}
          </li> */}

        {/* <li>
            <PrivyAuthButton />
          </li> */}
      </ul>
    </nav>
  );
};

export default Navigation;
